<div class="bg-pink env-indicator" *ngIf="isDevEnvironment">

</div>

<div class="bg-lime env-indicator" *ngIf="isTestEnvironment">

</div>